import { useClearErrorsAddress } from 'feature/addresses/hooks/useClearErrorsAddress'
import { useOnSelect } from 'feature/addresses/hooks/useOnSelect'
import { useSetAddressError } from 'feature/addresses/hooks/useSetAddressError'
import { useSetErrorAddress } from 'feature/addresses/hooks/useSetErrorAddress'
import { useAddressSliceActions } from 'feature/addresses/hooks/useAddressSliceActions'
import {
  useAddressState,
  AddressSliceKey,
} from 'feature/addresses/hooks/useAddressState'
import { yandexMap } from 'feature/addresses/redux/addressCreateSelector'
import { SavedAddress } from 'feature/addresses/redux/MyAddresses.api'
// eslint-disable-next-line max-len
import { moveMapBySuggestCordsAndPlaceMark } from 'feature/YandexMap/redux/actions/moveMapBySuggestCordsAndPlaceMark'
import { isAddressWithError } from 'helpers/addressErrorBoundary'
import { useEffect } from 'react'
import { useAppSelector, useThunkDispatch } from 'store/hooks'

export const useAddressInput = (addressKey: AddressSliceKey = 'default') => {
  const addressState = useAddressState(addressKey)
  const {
    input: inputAddress,
    inputSuggest,
    isError: isInputError,
    isDirty: isInputDirty,
    isLoadingSuggest,
  } = addressState

  const { clickMark } = useAppSelector(yandexMap)
  const { setIsValidAddress, setInputAddressSuggest, setInputAddress } =
    useAddressSliceActions(addressKey)
  const thunkDispatch = useThunkDispatch()

  const setErrorAddress = useSetErrorAddress(addressKey)
  const clearErrorsAddress = useClearErrorsAddress(addressKey)
  const onSelectHook = useOnSelect(addressKey)
  const setAddressError = useSetAddressError(addressKey)

  const validateAddress = () =>
    !isAddressWithError({ inputAddress, inputSuggest, setAddressError })

  const onClickAwayHandler = (
    e: MouseEvent | TouchEvent,
    externalHandler?: (e: MouseEvent | TouchEvent) => void,
  ) => {
    externalHandler?.(e)

    if (!inputAddress || (inputAddress.length === 0 && !clickMark.coords))
      return
    if (validateAddress()) setIsValidAddress(true)
  }

  useEffect(() => {
    clearErrorsAddress()
    return () => clearErrorsAddress()
  }, [])

  useEffect(() => {
    if (!clickMark.coords) return
    if (validateAddress()) {
      setIsValidAddress(true)
      clearErrorsAddress()
    }
  }, [clickMark])

  const handleUserAddressClick = (item: SavedAddress) => {
    setInputAddress(item.address)
    setIsValidAddress(true)
    setInputAddressSuggest(item)
    clearErrorsAddress()
    if (addressKey !== 'company') {
      thunkDispatch(moveMapBySuggestCordsAndPlaceMark())
    }
  }

  const hasError =
    isInputError &&
    !isLoadingSuggest &&
    ((inputAddress.length === 0 && isInputDirty) || inputAddress.length !== 0)

  return {
    addressState,
    hasError,
    onClickAwayHandler,
    handleUserAddressClick,
    onSelectHook,
    setErrorAddress,
    clearErrorsAddress,
  }
}
